import { useLayoutEffect } from 'react';
import './App.css';
import Home from './Components/Home/Home';

function App() {
  
  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const scrollToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    };

    scrollToTop();
    window.addEventListener('pageshow', scrollToTop);
    window.addEventListener('beforeunload', scrollToTop);

    return () => {
      window.removeEventListener('pageshow', scrollToTop);
      window.removeEventListener('beforeunload', scrollToTop);
    };
  }, []);

  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;